/**
 * 当前租户的行业码(调性档 chip 默认值用,0924 车 C)。
 *
 * 数据源 `GET /tenant/industry-kb/status`(租户三角色可读,代客落 actAsTenant;后端缺失兜底 IND_GENERIC)。
 * ★FSD:features 之间不互相 import,这里直接走 `@/shared/api`,不引 industry-kb feature 的 service;
 *   queryKey 与行业知识库页 `TenantView` 同一个,缓存共享(返回形状同为 `{ enabled, industryCode }`)。
 * 拉不到(平台超管未代客等)→ undefined,调性档退回 hardsell —— 与 ai 缺省一致,不挡创建流程。
 */
import { useQuery } from "@tanstack/react-query";

import { api } from "@/shared/api";
import { industryService } from "@/entities/industry";

export function useTenantIndustryCode(): string | undefined {
  const q = useQuery({
    queryKey: ["tenant-industry-kb-status"],
    queryFn: () =>
      api.get<{ enabled: boolean; industryCode: string }>("/tenant/industry-kb/status"),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return q.data?.industryCode || undefined;
}

/**
 * 当前租户的行业**中文名**(1004 T6:真人出镜样片脚本把「{行业}」换成租户行业)。
 * 通用 / 未设行业 / 拉不到 → undefined(调用方用中性词,不编一个行业)。
 * 名字走 `/tenant/industries`(xb_industry 真源),不在前端另抄一份码表。
 */
export function useTenantIndustryName(): string | undefined {
  const code = useTenantIndustryCode();
  const q = useQuery({
    queryKey: ["tenant-industries", "active"],
    queryFn: () => industryService.listForTenant({ status: "ACTIVE" }),
    enabled: !!code && code !== "IND_GENERIC",
    staleTime: 30 * 60 * 1000,
    retry: false,
    meta: { suppressGlobalErrorToast: true },
  });
  if (!code || code === "IND_GENERIC") return undefined;
  const name = q.data?.find((r) => r.code === code)?.name?.trim();
  return name || undefined;
}
